import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialBuyerFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import BuyersFilterData from "../../Buyers/components/BuyersFilterData";

const BuyerArchiveFilter = ({ filterData, onSetFilterData, onCallApiAgain , from }) => {
    const dropdownRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
        const id = localStorage.getItem("selectedSavefilterId");
        return id ? id : "";
    });

    const count = countNonMatchingEntries(filterData, initialBuyerFilterData);

    useEffect(() => {
        const handleClose = () => {
            setIsSidebarOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);

    const handleFilter = () => {
        localStorage.setItem("filterData", JSON.stringify(filterData));
        onCallApiAgain();
        setIsSidebarOpen(false);
        setSelectedSaveFilterId("");
    };

    const handleSelectFilter = (value) => {
        const dataToSet = {
            count: value?.count ?? "",
            start_count: value?.start_count ?? "",
            end_count: value?.end_count ?? "",

        };
        localStorage.setItem("filterData", JSON.stringify(dataToSet));
        onSetFilterData(dataToSet);
        onCallApiAgain(dataToSet);
    };

    const saveSearchFilterData = {
        count: filterData?.count ?? "",
        start_count: filterData?.start_count ?? "",
        end_count: filterData?.end_count ?? "",
    };

    return (
        <div>
            <SavedFilterComponent
                from="buyer"
                count={count}
                isSidebarOpen={isSidebarOpen}
                saveSearchFilterData={saveSearchFilterData}
                selectedSavefilterId={selectedSavefilterId}
                initialFilterData={initialBuyerFilterData}
                onCallApiAgain={onCallApiAgain}
                onSetFilterData={onSetFilterData}
                onSetSelectedSaveFilterId={(value) => {
                    setSelectedSaveFilterId(value);
                }}
                handleSelectFilter={handleSelectFilter}
                onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
            />

            <RightModal
                isOpen={isSidebarOpen}
                onClose={() => {
                    setIsSidebarOpen(false);
                    // onSetFilterData(initialBuyerFilterData);
                }}
                ref={dropdownRef}
                title={"Filter"}
                desc={"Enter buyers information."}
                onFilter={handleFilter}
                from="buyer"
                saveSearchFilterData={saveSearchFilterData}
                onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
            >
                <BuyersFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} from="buyerarchive" />
            </RightModal>
        </div>
    );
};

export default BuyerArchiveFilter;
